'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SelectableLabel = require('./SelectableLabel');

var _SelectableLabel2 = _interopRequireDefault(_SelectableLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectionList = function (_Component) {
  _inherits(SelectionList, _Component);

  function SelectionList(props) {
    _classCallCheck(this, SelectionList);

    var _this = _possibleConstructorReturn(this, (SelectionList.__proto__ || Object.getPrototypeOf(SelectionList)).call(this, props));

    _this.state = {
      available: _this.props.available,
      selected: _this.props.selected,
      hasSelected: _this.props.selected.length > 0
    };

    _this.isSelected = _this.isSelected.bind(_this);
    _this.hasSelected = _this.hasSelected.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleClear = _this.handleClear.bind(_this);
    _this.defaultAction = _this.defaultAction.bind(_this);
    return _this;
  }

  _createClass(SelectionList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var available = newProps.available,
          selected = newProps.selected;


      this.setState(function (prevState) {
        return _extends({}, prevState, {
          available: available,
          selected: selected
        });
      });
    }
  }, {
    key: 'isSelected',
    value: function isSelected(item) {
      var _this2 = this;

      return this.state.selected.indexOf(item) > -1 || this.state.selected.find(function (sel) {
        return sel.id && sel.id === item.id && (!sel[_this2.props.groupKey] || sel[_this2.props.groupKey] === item[_this2.props.groupKey]);
      }) !== undefined;
    }
  }, {
    key: 'hasSelected',
    value: function hasSelected() {
      return this.state.selected.length > 0;
    }
  }, {
    key: 'handleClick',
    value: function handleClick(item) {
      return this.props.action.call(this, item);
    }
  }, {
    key: 'handleClear',
    value: function handleClear() {
      return this.props.clear.call(this);
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(item, event) {
      if (event.key === 'Enter') {
        this.handleClick(item);
      }
    }
  }, {
    key: 'defaultAction',
    value: function defaultAction(item) {
      return SelectionList.defaultAction.call(this, item);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var filters = this.state.available.map(function (item, i) {
        var groupSlug = item[_this3.props.groupKey] && item[_this3.props.groupKey].replace(/\W+/g, '-').toLowerCase();

        return _react2.default.createElement(
          'li',
          {
            className: item[_this3.props.customClassKey],
            key: '' + (groupSlug ? groupSlug + '-' : '') + item[_this3.props.idKey] || i
          },
          _react2.default.createElement(_SelectableLabel2.default, {
            action: _this3.handleClick.bind(_this3, item),
            label: item[_this3.props.labelKey],
            group: item[_this3.props.groupKey],
            selected: _this3.isSelected(item),
            appearance: _this3.props.appearance,
            iconSelected: _this3.props.iconSelected,
            iconUnselected: _this3.props.iconUnselected
          })
        );
      });

      if (this.props.clearText && (!this.props.hideClearWhenEmpty || this.hasSelected())) {
        var clear = _react2.default.createElement(
          'li',
          { className: 'clear', key: 'clear' },
          _react2.default.createElement(_SelectableLabel2.default, {
            action: this.handleClear,
            label: this.props.clearText,
            selected: !this.hasSelected(),
            iconSelected: this.props.iconSelected || 'checkmark',
            iconUnselected: this.props.iconUnselected || 'x'
          })
        );

        if (this.props.clearPosition === 'last') {
          filters.push(clear);
        } else {
          filters.unshift(clear);
        }
      }

      var layoutClassNames = (this.props.layout === 'grid' ? 'columns-' + this.props.columns : '') + ' ';
      var listClassNames = (this.hasSelected() ? 'selected' : '') + ' ' + this.props.layout;

      return _react2.default.createElement(
        'div',
        { className: '' + layoutClassNames },
        _react2.default.createElement(
          'ul',
          { className: 'SelectionList ' + this.props.customClassName + ' ' + listClassNames },
          filters
        )
      );
    }
  }]);

  return SelectionList;
}(_react.Component);

SelectionList.propTypes = {
  /** Function with an item as its argument that is called on a click. */
  action: _propTypes2.default.func,
  /** The appearance of SelectableLabels. */
  appearance: _propTypes2.default.oneOf(['plain', 'filter', 'tag']),
  /** All available items. */
  available: _propTypes2.default.array.isRequired,
  /** Function to clear the selection */
  clear: _propTypes2.default.func,
  /** Whether to display the clear button first or last */
  clearPosition: _propTypes2.default.oneOf(['first', 'last']),
  /** Text to display on the "Clear" or "Show all" item, the first of the list. */
  clearText: _propTypes2.default.string,
  /** Number of grid columns when using the `grid` layout. */
  columns: _propTypes2.default.number,
  /** Key in each item of available to use as as className. */
  customClassKey: _propTypes2.default.string,
  /** Class name to apply to the SelectionList element. */
  customClassName: _propTypes2.default.string,
  /** Key in each item of available to use as a group */
  groupKey: _propTypes2.default.string,
  /** Whether to show the Clear button when there are no selected items. */
  hideClearWhenEmpty: _propTypes2.default.bool,
  /** The name of the icon to pass to SelectionLabel for selected items. */
  iconSelected: _propTypes2.default.string,
  /** The name of the icon to pass to SelectionLabel for unselected items. */
  iconUnselected: _propTypes2.default.string,
  /** Key in each item of available to use as a key (unique identifier). Fallbacks on index. */
  idKey: _propTypes2.default.string,
  /** Key in each item of available to use as a label */
  labelKey: _propTypes2.default.string,
  /** Display labels as a linear list, an inline list, or a grid. */
  layout: _propTypes2.default.oneOf(['list', 'grid', 'inline', 'commaSeparated']),
  /** Selected items. */
  selected: _propTypes2.default.array
};
SelectionList.defaultProps = {
  action: function action() {},
  appearance: 'filter',
  clear: function clear() {},
  clearPosition: 'first',
  clearText: '',
  columns: 2,
  customClassName: '',
  customClassKey: 'class',
  groupKey: 'group',
  hideClearWhenEmpty: false,
  iconSelected: 'x',
  iconUnselected: null,
  idKey: 'id',
  labelKey: 'label',
  selected: [],
  layout: 'list'
};
exports.default = SelectionList;
SelectionList.__docgenInfo = {
  'description': '',
  'methods': [{
    'name': 'isSelected',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'item',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'hasSelected',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }, {
    'name': 'handleClick',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'item',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'handleClear',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }, {
    'name': 'handleKeyPress',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'item',
      'type': null
    }, {
      'name': 'event',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'defaultAction',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'item',
      'type': null
    }],
    'returns': null
  }],
  'displayName': 'SelectionList',
  'props': {
    'action': {
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Function with an item as its argument that is called on a click.'
    },
    'appearance': {
      'defaultValue': {
        'value': '\'filter\'',
        'computed': false
      },
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'plain\'',
          'computed': false
        }, {
          'value': '\'filter\'',
          'computed': false
        }, {
          'value': '\'tag\'',
          'computed': false
        }]
      },
      'required': false,
      'description': 'The appearance of SelectableLabels.'
    },
    'clear': {
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Function to clear the selection'
    },
    'clearPosition': {
      'defaultValue': {
        'value': '\'first\'',
        'computed': false
      },
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'first\'',
          'computed': false
        }, {
          'value': '\'last\'',
          'computed': false
        }]
      },
      'required': false,
      'description': 'Whether to display the clear button first or last'
    },
    'clearText': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Text to display on the "Clear" or "Show all" item, the first of the list.'
    },
    'columns': {
      'defaultValue': {
        'value': '2',
        'computed': false
      },
      'type': {
        'name': 'number'
      },
      'required': false,
      'description': 'Number of grid columns when using the `grid` layout.'
    },
    'customClassName': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Class name to apply to the SelectionList element.'
    },
    'customClassKey': {
      'defaultValue': {
        'value': '\'class\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Key in each item of available to use as as className.'
    },
    'groupKey': {
      'defaultValue': {
        'value': '\'group\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Key in each item of available to use as a group'
    },
    'hideClearWhenEmpty': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether to show the Clear button when there are no selected items.'
    },
    'iconSelected': {
      'defaultValue': {
        'value': '\'x\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The name of the icon to pass to SelectionLabel for selected items.'
    },
    'iconUnselected': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The name of the icon to pass to SelectionLabel for unselected items.'
    },
    'idKey': {
      'defaultValue': {
        'value': '\'id\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Key in each item of available to use as a key (unique identifier). Fallbacks on index.'
    },
    'labelKey': {
      'defaultValue': {
        'value': '\'label\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Key in each item of available to use as a label'
    },
    'selected': {
      'defaultValue': {
        'value': '[]',
        'computed': false
      },
      'type': {
        'name': 'array'
      },
      'required': false,
      'description': 'Selected items.'
    },
    'layout': {
      'defaultValue': {
        'value': '\'list\'',
        'computed': false
      },
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'list\'',
          'computed': false
        }, {
          'value': '\'grid\'',
          'computed': false
        }, {
          'value': '\'inline\'',
          'computed': false
        }, {
          'value': '\'commaSeparated\'',
          'computed': false
        }]
      },
      'required': false,
      'description': 'Display labels as a linear list, an inline list, or a grid.'
    },
    'available': {
      'type': {
        'name': 'array'
      },
      'required': true,
      'description': 'All available items.'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/SelectionList.js
// module id = 145
// module chunks = 0